export const ProcessModuleQuestions = [
    {
        header: 'JAK VYPADÁ PROCES UVÁDĚNÍ VÝROBKU NA TRH?',
        answers: [
            {
                content: 'Mám dobrý nápad a někomu ho prostě prodám',
            },

            {
                content: 'Je to komplikovaný proces, na kterém se podílí řada subjektů',
            },

            {
                content: 'Je to proces, který začíná vývojem produktu, pokračuje jeho analýzou, rozvojem produktu, testováním a komercializací.',
                correct: true,
            },
        ],
    },
    {
        header: 'JAK MÁM URČIT CENU SVÉHO PRODUKTU?',
        answers: [
            {
                content: 'Zeptám se kamarádů a případně zavolám příteli na telefonu',
            },

            {
                content: 'Vyhledám si na Googlu ceny podobných výrobků a nasadím svou cenu levnější, abych vyvolal zájem zákazníků.',
            },

            {
                content: 'Otestuji si navrhovanou cenu na malém reprezentativním vzorku populace.',
                correct: true,
            },
        ]
    },
    {
        header: 'KTERÉ PRVKY URČUJÍ ÚSPĚŠNOST MÉHO PRODUKTU?',
        answers: [
            {
                content: 'Moje genialita',
            },

            {
                content: 'Situace na trhu, konkurenční nabídka, navrhovaná cena, způsob distribuce.',
                correct: true,
            },

            {
                content: 'Marketingvý mix a nálada potenciálních zákazníků.',
            },
        ],
    },
    {
        header: 'JAK NAJDU MOŽNÉ ZÁJEMCE O MŮJ PRODUKT, POKUD JE TO B2B VÝROBEK?',
        answers: [
            {
                content: 'Vyhledám si je v databázích Bisnode, Merk nebo podobných.',
                correct: true,
            },

            {
                content: 'Obvolám ředitele všech firem, které se podobnými produkty zabývají, a pozvu je na oběd',
            },

            {
                content: 'Zkusím se zeptat na příslušném ministerstvu.',
            },
        ],
    }
];
